import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { TranslatePipe } from '@ngx-translate/core';

export interface ChangelogEntry {
  version: string;
  date: string;
  sections: {
    tag: 'new' | 'improved' | 'fixed';
    label: string;
    items: string[];
  }[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '3.18.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Home in tre fasce: In primo piano, In arrivo, Il tuo percorso',
          'Prossimo evento con conto alla rovescia e la prossima prova nella stessa card',
          '"Da tenere d\'occhio": promemoria del calendario e preventivi o firme in scadenza',
          'Nuovo contatore "Preventivi inviati"; eventi svolti, contratti firmati e incassato da sempre',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Home più ariosa e ordinata, anche da telefono',
          'Icone "i" più discrete: col mouse si aprono al passaggio',
        ],
      },
    ],
  },
  {
    version: '3.17.2',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Contratto firmato: un solo pulsante "Scarica", nella card del contratto',
        ],
      },
    ],
  },
  {
    version: '3.17.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'La scheda evento si apre sempre in lettura e ti dice in alto cosa manca per il contratto: tocca una voce per compilarla',
          '"+ Aggiungi" su orario, luogo, telefono ed email quando sono vuoti',
        ],
      },
    ],
  },
  {
    version: '3.17.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Il primo accesso mostra tutte le tappe, "Passo X di 5": chi sei, studio, firma, contratto e listino',
          'Da Nuovo evento, se il listino è vuoto, puoi aggiungere una voce al volo senza perdere quello che hai scritto',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Se ricarichi la pagina durante il primo accesso riparti da dove eri, con i dati già inseriti',
          '"Salta tutto" porta direttamente alla Home',
          'Le spiegazioni delle icone "i" restano sempre dentro lo schermo',
        ],
      },
    ],
  },
  {
    version: '3.16.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Più sicurezza: dopo troppi tentativi di accesso falliti bisogna aspettare qualche minuto prima di riprovare',
          'Collaboratori e team ricevono solo le sezioni dell’evento che hai scelto di mostrare, non solo nell’app ma anche nei dati',
        ],
      },
    ],
  },
  {
    version: '3.15.2',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Pannello admin da telefono: riquadri per le sezioni, utenti a card con dettagli e azioni in un pannello dal basso',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Pannello admin: il grafico dei nuovi eventi per mese mostrava barre schiacciate',
        ],
      },
    ],
  },
  {
    version: '3.15.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Scheda evento più ordinata da computer: tab più chiari, titoli e campi meglio distinti, modifica più leggibile',
          'Telefono della cliente con il prefisso internazionale, come quello dello studio',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Ricerca eventi: ora trova anche nome e cognome scritti insieme, e il suggerimento apre direttamente l\'evento',
          'Il tasto Modifica non copre più il primo blocco della scheda evento',
        ],
      },
    ],
  },
  {
    version: '3.15.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Preventivo: puoi preparare più proposte alternative nello stesso preventivo, dalla scheda Servizi',
          'La cliente vede tutte le proposte dal link e sceglie quella che preferisce',
        ],
      },
    ],
  },
  {
    version: '3.14.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Preventivo e firma: i link da mandare alla cliente sono molto più corti, comodi da incollare su WhatsApp',
        ],
      },
    ],
  },
  {
    version: '3.14.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Scheda evento: nuova scheda Servizi, con servizi, trasferta e sconto',
          'Preventivo: la validità del link si può dare anche come data di scadenza, non solo in giorni',
          'Eventi: puoi ordinare la lista per ultimi inseriti',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Scheda evento: i dati della cliente sono nella scheda Evento, il contratto è insieme ai documenti',
          'Nuovo evento: il cognome è subito sotto il nome',
          'Gli eventi dello stesso giorno sono in ordine di orario',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Da telefono la finestra della mail del preventivo ora scorre e il pulsante Copia è sempre visibile',
        ],
      },
    ],
  },
  {
    version: '3.13.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Voci fuori listino: aggiungi all\'evento un servizio che non è nel tuo listino',
          'Preventivo: puoi mostrare le note alla cliente',
          'Preventivo: avviso che in caso di modifiche o aggiunte il prezzo potrà variare',
        ],
      },
    ],
  },
  {
    version: '3.12.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Pagina di presentazione: l\'iscrizione alla lista d\'attesa si può accendere e spegnere per ambiente',
        ],
      },
    ],
  },
  {
    version: '3.12.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Pagina di presentazione di Nyzed con lista d\'attesa per il lancio',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Il progetto si chiama Nyzed anche in email, contratti e pagina di firma',
        ],
      },
    ],
  },
  {
    version: '3.11.3',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Se i dati non si caricano l\'app lo dice e ti fa riprovare, invece di mostrare pagine vuote',
          'Finché i dati non sono arrivati non puoi salvare per sbaglio sopra quelli veri',
          'Riaprendo l\'app dal telefono dopo un po\' i dati si aggiornano da soli',
          'Listino da telefono: la promo non copre più la descrizione del servizio',
        ],
      },
    ],
  },
  {
    version: '3.11.2',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Cambiare la validità di un preventivo già inviato ora chiede conferma, perché il link vecchio smette di funzionare',
          'Nella scheda evento i servizi selezionati si vedono sempre, anche da telefono',
          'Da telefono, con l\'app aperta a lungo, i dati si aggiornano da soli',
        ],
      },
    ],
  },
  {
    version: '3.11.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Un preventivo senza data accettato dalla cliente si può di nuovo modificare: compare l\'avviso "Data da fissare" finché non imposti il giorno',
          'Per confermare a mano un preventivo serve prima la data dell\'evento',
          'La validità di base del link del preventivo è di 30 giorni',
        ],
      },
    ],
  },
  {
    version: '3.11.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Preventivo senza data: indichi un periodo (anno e, se vuoi, mese o stagione) finché la data non è decisa',
          'I preventivi senza data restano visibili nella lista eventi, in fondo, e il contratto si genera solo con una data precisa',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'La ricerca degli eventi guarda su tutto, anche con un filtro attivo',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Il footer resta in fondo alla pagina anche nelle pagine corte',
        ],
      },
    ],
  },
  {
    version: '3.10.2',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Cambiando account nella stessa scheda non compaiono più le notifiche dell\'utente precedente',
        ],
      },
    ],
  },
  {
    version: '3.10.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Il preventivo ora vale 30 giorni di base, modificabili nelle impostazioni',
          'Dalla finestra "Copia mail" scegli i giorni di validità del singolo preventivo',
        ],
      },
    ],
  },
  {
    version: '3.10.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Carica il logo della tua attività dal profilo, nei dati studio',
          'Il logo compare nel contratto PDF, nel preventivo, nella pagina di firma e nella mail del preventivo',
        ],
      },
    ],
  },
  {
    version: '3.9.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Copia la mail del preventivo già pronta e mandala dal tuo programma di posta',
          'Scegli se includere il link per accettare online e in che lingua scrivere la mail',
        ],
      },
    ],
  },
  {
    version: '3.8.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Nel preventivo i servizi scontati mostrano il prezzo pieno barrato e il nome dello sconto',
        ],
      },
    ],
  },
  {
    version: '3.8.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Dai un nome agli sconti del listino, per esempio "Promo Tutto Sposi"',
          'Nel contratto PDF i servizi scontati mostrano il prezzo pieno barrato e il prezzo scontato',
        ],
      },
    ],
  },
  {
    version: '3.7.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Sconto a tempo sui servizi del listino: imposti il prezzo scontato e la data di fine, poi il prezzo torna da solo quello pieno',
          'Nel listino il prezzo pieno compare barrato accanto a quello scontato',
        ],
      },
    ],
  },
  {
    version: '3.6.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Novità',
        items: [
          'Preventivi: crea l\'evento come preventivo, invialo alla cliente con un link e ricevi la sua accettazione online',
          'Quando la cliente accetta, l\'evento diventa confermato e ti arriva una notifica',
          'Sconto in euro o in percentuale, visibile su preventivo, contratto e pagamenti',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'I preventivi non ancora confermati restano fuori da entrate previste e statistiche',
          'Avviso se crei un evento in una data che ha già un evento confermato',
        ],
      },
    ],
  },
  {
    version: '3.5.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Firma del contratto: la cliente può leggere il contratto prima di firmare, e il PDF firmato si crea da solo',
          'Se cambi i dati dopo aver generato il contratto, il vecchio link di firma viene annullato: così la cliente firma sempre la versione giusta',
          'Più protezione sui tuoi eventi: li vedi solo tu e le persone che hai invitato',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Per creare un evento bastano davvero nome e data',
          'Il totale mostrato alla cliente nella pagina di firma ora coincide con il contratto',
          'Scaricare il contratto e le sue versioni precedenti funziona sempre',
        ],
      },
    ],
  },
  {
    version: '3.5.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Icone nuove in tutta l\'app: lo stesso stile pulito della scheda evento al posto delle emoji',
          'Le icone seguono i colori del tema che hai scelto',
        ],
      },
    ],
  },
  {
    version: '3.4.1',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Riaprendo l\'app dopo un po\' non ti chiede più di rifare il login ogni volta',
        ],
      },
    ],
  },
  {
    version: '3.4.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Creare un evento è più veloce: bastano nome e data, il resto lo aggiungi quando vuoi',
          'Puoi inserire la trasferta già quando crei l\'evento',
          'Se chiedi il contratto alla creazione, si apre subito l\'anteprima da controllare prima di salvarlo',
          'Gli orari si scelgono a scatti di 15 minuti, niente più 13:53',
          'Nel contratto finisce l\'acconto che hai segnato nei Pagamenti dell\'evento',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Nel contratto comparivano scritte come {{nome_sposa}} invece del nome della cliente',
          'Toccando due volte "Crea evento" poteva nascere un evento doppio',
          'Da smartphone i pulsanti dell\'anteprima del contratto finivano sotto la barra in basso',
        ],
      },
    ],
  },
  {
    version: '3.3.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Calendario da smartphone tutto nuovo: tocchi un giorno e vedi i suoi eventi, scorri tra i mesi con il dito e crei un evento con "+ Nuovo"',
          'Toccando un evento nel calendario si apre un riepilogo con meteo, stato del contratto e pulsanti per chiamare o avere le indicazioni',
          'In Contratti vedi subito quali sono firmati e quali aspettano ancora la firma',
          'Statistiche: scegli l\'anno e guarda quanto hai davvero incassato mese per mese',
          'Rubrica collaboratori ridisegnata: più chiara da leggere e da modificare',
          'Impostazioni da smartphone in un elenco ordinato, come sul telefono',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Il pulsante "Scheda" nella pagina Contratti portava a una pagina inesistente',
          'Nella Rubrica "Annulla" non annullava le modifiche',
          'Alcune pagine non erano tradotte in inglese e spagnolo',
        ],
      },
    ],
  },
  {
    version: '3.2.0',
    date: 'Ottobre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Scheda evento più semplice da smartphone: 4 schede invece di 8, con icone e il nome della scheda in cui ti trovi',
          'In cima alla scheda vedi subito quanti giorni mancano, a che punto sono contratto, pagamenti e team, e puoi chiamare, scrivere su WhatsApp o aprire le indicazioni con un tocco',
          'Contratto a tappe: un solo pulsante ti dice cosa fare dopo, e il link di firma si manda direttamente su WhatsApp o per email',
          'Pagamenti: segna acconto e saldo come incassati con un tocco, aggiungi data e metodo, imposta la scadenza del saldo e manda il riepilogo alla cliente',
          'Foto dell\'evento in una sezione dedicata, da aggiungere al volo dalla fotocamera',
          'Puoi salvare telefono ed email della cliente',
          'Home da smartphone più completa: contatori, prossimo evento, cose da fare e prossima prova',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Il salvataggio di un evento poteva fallire se l\'email della cliente era lasciata vuota',
          'Il pulsante Modifica ora c\'è in tutte le schede, con Salva e Annulla sempre a portata di mano in basso',
        ],
      },
    ],
  },
  {
    version: '3.1.0',
    date: 'Settembre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Navigazione da smartphone rinnovata: barra in basso con Home, Calendario, Crea evento, Notifiche e Altro, come in un\'app',
          'Home da smartphone ridisegnata: saluto, azioni rapide e prossimi eventi in card, tutto subito a portata di pollice',
          'Calendario da smartphone: vista a lista leggibile come impostazione predefinita, con un tasto per tornare alla griglia mensile',
          'Crea evento da smartphone: le sezioni del form si aprono una alla volta invece di scorrere tutte insieme',
          'Lista eventi da smartphone: filtri per tipo, anno e vista mappa raccolti in un pannello dedicato, per lasciare subito spazio alla ricerca',
          'Nuova sezione "Assistenza" in Impostazioni per aprire la chat di supporto quando serve',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Pagina che "scivolava" lateralmente su smartphone durante la navigazione',
          'Bottone chiusura della galleria foto che poteva finire fuori schermo su foto molto alte',
          'Aree di tocco troppo piccole in vari punti da smartphone (calendario, filtri eventi, link di login)',
          'Chat di supporto: il bottone fluttuante restava sempre visibile e dava fastidio su smartphone',
        ],
      },
    ],
  },
  {
    version: '3.0.0',
    date: 'Settembre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'L\'app diventa Nyzed — nuovo nome, logo, palette colori (arancio e lavanda su blu notte) e font (Bumble + Nunito)',
          'Nuovo tema di default con i colori Nyzed; la vecchia palette resta disponibile come tema "Romantico Floreale" in Profilo → Aspetto',
          'Tutti gli altri temi selezionabili ridisegnati in chiave Nyzed, incluso il tema accessibilità "Alto Contrasto"',
          'Pagine di accesso e registrazione rinnovate, con il nuovo logo e un tono più diretto',
        ],
      },
    ],
  },
  {
    version: '2.7.0',
    date: 'Settembre 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Meteo nel calendario — previsioni per matrimoni e prove nei prossimi 15 giorni, con un consiglio pratico in base al tempo previsto',
          'Cliccando su un evento nel calendario si apre un riepilogo rapido (data, meteo, stato contratto e acconto) con un bottone per aprire la scheda completa',
          'Click su un giorno vuoto del calendario per creare un evento al volo, con data già impostata',
          'La legenda del calendario è ora anche un filtro: nascondi matrimoni o prove con un click',
          'Striscia con numero di eventi del mese e giorni al prossimo evento, sopra il calendario',
          'Promemoria: checklist libera per appunti non legati a un evento, sotto il calendario',
          'Nuovo tema "Mediterraneo" (Pro/Agency) — terracotta e verde bosco',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Popover "+N altri" del calendario brandizzato invece del grigio di default',
          '"Modifica" ed "Elimina evento" di nuovo affiancati in alto nella scheda evento',
        ],
      },
    ],
  },
  {
    version: '2.6.1',
    date: 'Settembre 2026',
    sections: [
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'Pannello admin: lo status "in prova" restava mostrato anche per chi aveva la prova scaduta, sia nella lista utenti che nelle statistiche — ora si basa sul calcolo reale, non sul dato grezzo salvato',
        ],
      },
    ],
  },
  {
    version: '2.6.0',
    date: 'Agosto 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Elimina evento — nuovo bottone in scheda evento (solo per chi lo ha creato), con conferma esplicita: cancella anche foto, documenti e contratto collegati',
        ],
      },
      {
        tag: 'fixed',
        label: 'Corretto',
        items: [
          'La trasferta ora compare nel PDF del contratto generato, prima mancava',
          'Corretto un problema di sicurezza: l\'eliminazione di un evento ora verifica che appartenga davvero a chi la richiede',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'L\'impostazione "mostra totale nel contratto" si trova ora in Impostazioni → Contratto invece che nel Listino',
        ],
      },
    ],
  },
  {
    version: '2.5.0',
    date: 'Agosto 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Mostra/nascondi password — icona occhio nei campi password di accesso e registrazione',
          'Acconto a percentuale — oltre all\'importo fisso in euro, ora si può impostare come percentuale del totale, uniformato tra scheda Contratto e tab Pagamenti dell\'evento',
          'Firma caricabile da PNG — oltre a disegnarla, si può caricare un file immagine (profilo, onboarding, firma cliente da link)',
          'Prefisso telefonico internazionale nei campi telefono del contratto',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Font più grandi in tutta l\'app; riabilitato lo zoom manuale (pinch) su mobile',
          'Dopo il login da un link che richiedeva l\'accesso, si torna alla pagina originariamente richiesta invece di finire sempre in home',
          'Verifica anti-spam in registrazione meno invadente: compare solo quando serve davvero',
          'Le email di conferma/benvenuto non mostrano più il link "Gestisci le preferenze"',
          'Niente più maiuscola automatica nei campi email',
        ],
      },
    ],
  },
  {
    version: '2.4.0',
    date: 'Agosto 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Accedi con Google — disponibile sia in accesso che in registrazione. Se l\'email corrisponde a un account Nyzed già esistente, viene chiesta conferma prima di collegarlo.',
        ],
      },
    ],
  },
  {
    version: '2.3.0',
    date: 'Agosto 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Icone ⓘ informative accanto ai campi meno intuitivi (onboarding, home, creazione evento, impostazioni contratto)',
          'Ogni scheda principale ora spiega in una riga a cosa serve (evento, cliente, contratto, pagamenti, documenti, profilo, impostazioni...)',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'La generazione del contratto ora mostra sempre una conferma di successo o un errore visibile, prima poteva fallire in silenzio',
          'La modifica di didascalia/nota di una foto ora mostra una conferma di salvataggio',
        ],
      },
    ],
  },
  {
    version: '2.2.0',
    date: 'Agosto 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Personalizzazione del tema (Profilo → tab Aspetto): 7 palette colore, inclusa Notte (modalità scura) e Alto Contrasto — gratuito per tutti, pensato per la leggibilità',
          'Conferma email obbligatoria alla registrazione, con possibilità di richiedere un nuovo link se scaduto o perso',
          'Avviso "Bloc Maiusc attivo" sotto i campi password in accesso e registrazione',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'App più comoda da telefono: niente più zoom automatico sui campi, aree di tocco più ampie su pulsanti e azioni (galleria foto, mappa eventi, documenti, ricerca, pannello Admin, navbar)',
          'Flusso dopo la registrazione riordinato: wizard di onboarding → configurazione contratto → listino servizi → home',
          'Dati contratto uniformati tra Impostazioni e scheda evento, con possibilità di personalizzare i dati per il singolo evento',
          'Riepilogo anno in Home: la voce economica è ora "Entrate previste"; Home più snella',
          'I messaggi popup ora usano il maiuscolo per una lettura più netta',
          'Rinominato "Calendario Matrimoni" in "Calendario Eventi"',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Corretto "Mostra totale" nel contratto: ora compare o sparisce correttamente in base all\'impostazione',
          'Corretta la personalizzazione del contratto per singolo evento, che non veniva mai usata davvero nella generazione del PDF',
          'Corrette le card di riepilogo delle statistiche feedback (Admin), non visibili anche da desktop',
          'Il footer resta correttamente in fondo alla pagina anche nelle schermate con pochi contenuti',
          'Numerosi punti dell\'interfaccia che restavano con colori fissi indipendentemente dal tema scelto',
        ],
      },
    ],
  },
  {
    version: '2.1.0',
    date: 'Luglio 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Abbonamenti: tre piani (Base, Pro, Agency) con una nuova pagina dedicata dal menu account, gestione in autonomia (disdici/riattiva) e prova gratuita di 30 giorni',
          'Pagina Statistiche: con Pro sblocchi la dashboard completa — valore medio evento, fatturato stimato, eventi per mese, trasferte, città e mappa',
          'Email abbonamenti: attivazione, pagamento non riuscito, disdetta e prova in scadenza',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Funzioni per piano: mappe, statistiche e temi del contratto con Pro; team e collaboratori con Agency. Ciò che hai già creato resta sempre accessibile',
        ],
      },
    ],
  },
  {
    version: '2.0.0',
    date: 'Luglio 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Home rinnovata: una dashboard con eventi in arrivo, contratti da generare, saldo aperto, agenda e riepilogo dell\'anno',
          'Navbar rinnovata e nuova pagina Listino dedicata',
          'Mappe: autocomplete degli indirizzi, mini-mappa nella scheda evento e vista Mappa nella lista eventi',
          'Trasferte: calcolo automatico del costo dalla distanza (andata e ritorno) × la tua tariffa €/km, più statistiche in Home',
          'Contratto PDF rinnovato: generato dal server, con font eleganti (Cormorant + Jost), temi grafici e intestazione con il nome del tuo studio',
          'Pagamenti evento: nuova sezione con acconto, saldo e stato di incassato / da incassare',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Addio pacchetti: ora si usa un unico Listino servizi (gli eventi esistenti vengono migrati automaticamente)',
          'Impostazioni contratto spostate nella sezione Contratti, con wizard guidato passo-passo',
          'Nella tab Servizi la sezione "Partecipanti" è ora "Clienti"',
          'Tariffa trasferta spostata nella sezione Pagamento delle impostazioni contratto',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Registrazione: il captcha non si blocca più dopo un tentativo fallito (niente più refresh della pagina)',
          'Home: i totali di saldo e incassato non risultano più a zero',
        ],
      },
    ],
  },
  {
    version: '1.10.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Documenti evento: nuova sezione per caricare, scaricare, rinominare e annotare i tuoi file (PDF, Office, immagini) direttamente nella scheda evento',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Foto evento: ora puoi rinominarle, aggiungere note ed eliminarle al volo, senza modalità modifica',
          'Visualizzatore foto più pulito e ottimizzato per telefono; tocca un\'anteprima per cambiare foto',
        ],
      },
    ],
  },
  {
    version: '1.9.1',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Tour guidato: il pulsante "Rivedi" riapre la guida portandoti subito sulla pagina giusta',
          'Impostazioni: banner informativo delle notifiche sempre visibile',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Accesso a una sezione senza permessi: non vieni più disconnessa — avviso e ritorno alla home',
        ],
      },
    ],
  },
  {
    version: '1.9.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Navbar mobile ridisegnata: link scorrevoli + campanella e avatar che apre il menu account',
          'Pannello admin: tabella utenti a card, leggibile su telefono',
          'Tab scrollabili in orizzontale su scheda evento e profilo',
          'Home: card del prossimo evento visibile anche su mobile',
          'Scheda evento: righe servizi/pacchetti e partecipanti adattate ai telefoni',
          'Contratto: linguaggio inclusivo e generico ("fornitor* di servizi per eventi", denominat* FORNITORE)',
          'Contratto: requisiti location generici (rimosso "team di bellezza")',
          'Contratto: data della firma sotto entrambe le firme (Cliente e Fornitore)',
          'Wizard iniziale: tasti Indietro, validazione email, a fine si va al profilo',
          'Loader di caricamento ridisegnato (più pulito)',
          'Avvisi e dialog uniformati allo stile dell\'app e tradotti',
          'Performance: meno chiamate al server e lista eventi riusata tra le pagine — app più reattiva',
        ],
      },
    ],
  },
  {
    version: '1.8.2',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Navbar mobile: aggiunti "Esci" e "Admin Panel" al menu (prima mancavano); corretto il menu che si tagliava',
          'Onboarding: griglia categorie a colonna singola sui telefoni piccoli',
        ],
      },
    ],
  },
  {
    version: '1.8.1',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Sezione "Altro" nel contratto (titolo + testo libero), inclusa nel PDF generato',
          'Campo IBAN nel profilo (sezione Pagamento, su bonifico/entrambi) — incluso nella clausola di pagamento del contratto',
          'Admin: per i membri del team viene mostrato il titolare a cui sono associati',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Sezione contratto del profilo: note guidate rinominate "Testo libero" con box bianco e spaziatura; rimossa la vecchia sezione "Testo libero contratto" ad accordion',
          'Cambio ruoli utente ristretto ai soli amministratori completi',
        ],
      },
    ],
  },
  {
    version: '1.8.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Visibilità sezioni — scegli quali sezioni degli eventi vedono Collaboratori e Team, con valori predefiniti nel profilo (nuova tab "Visibilità") e override per singolo evento',
          'Vista team arricchita — i membri del team ora vedono anche foto, servizi/pacchetti e partecipanti dell\'evento, in base ai permessi',
          'Marcatore "● Compare nel contratto" sui campi della scheda evento, con legenda',
          'Pulsante home dinamico: "Inizia ora" diventa "Crea evento" dopo il primo salvataggio del profilo',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Foto eventi compresse automaticamente in upload — caricamenti più rapidi e meno spazio',
          'Scheda evento: "Data matrimonio" → "Data evento", "firma sposa" → "firma cliente"',
          'Scheda cliente: campo indirizzo ora "Indirizzo di residenza"',
        ],
      },
    ],
  },
  {
    version: '1.7.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Team — invita i membri del tuo staff via email: accedono in sola lettura ai matrimoni che assegni loro (nuova tab nel profilo)',
          'Collaborazioni — pagina dedicata nella navbar per la tua rubrica di collaboratori, separata dal Team',
          '"Invita su Nyzed" — invita un contatto a iscriversi con email brandizzata',
          'Assegnazione team sull\'evento divisa in Team (con accesso) e Collaboratori (rubrica)',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Le email di invito (team e referral) indicano chiaramente chi invita',
          'Footer email personalizzato in base al tipo di invito',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Pagina di attivazione team senza stile (CSS mancante)',
          'Date senza mese nella pagina "I tuoi eventi" del membro team',
        ],
      },
    ],
  },
  {
    version: '1.6.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Admin panel v2 — sistema di ruoli (Admin, Admin Readonly, Support, Stats) con permessi differenziati',
          'Pagina statistiche rinnovata — KPI card, breakdown utenti, rate firma contratti, grafico mensile',
          'Tabella utenti con menu compatto — toggle stato, reset password, gestione ruolo, eliminazione',
          'Modal gestione ruolo — scegli il ruolo con descrizione e permessi per ogni utente',
          'Navbar dropdown Impostazioni — logout, link admin panel, accesso rapido alle preferenze',
          'Badge Nyzed nel team — identifica se un collaboratore è utente Nyzed (⚡ badge)',
          'Impostazioni notifiche email — scegli quali email ricevere con 8 toggle configurabili',
          'Pulsante "Invia mail di prova" per testare ogni template prima di riceverlo',
          'Preferenze sincronizzate sul server — lingua e impostazioni non si perdono cambiando dispositivo',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Email con link diretto alla sezione pertinente (scheda evento, contratti, novità)',
          'Footer email con link "Gestisci le preferenze email"',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Doppio "Ciao [nome]" nelle email di prova',
          'Logo corretto nella tab del browser',
        ],
      },
    ],
  },
  {
    version: '1.5.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Wizard di onboarding guidato al primo accesso — 4 step: categoria, dati studio, firma, primo pacchetto',
          'Tour interattivo dell\'app — highlight delle sezioni principali con spiegazioni contestuali',
          'Pagina Impostazioni — lingua, tour, notifiche e account in un unico posto',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Categoria professionale — ora multiselezione (es. Makeup + Hair Stylist insieme)',
          'Registrazione semplificata — rimossa la selezione attività, gestita nel wizard',
          'Tab "Prova" rinominato "Sopralluogo" per fotografi, DJ, fioristi e altri professionisti',
        ],
      },
    ],
  },
  {
    version: '1.4.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Categoria professionale nel profilo — makeup, hair, fotografo, videomaker, DJ, musica live, fiorista',
          'Tab "Prova" diventa "Sopralluogo" per fotografi, DJ, fioristi e altri professionisti',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Stile degli input password nel form modifica profilo',
        ],
      },
    ],
  },
  {
    version: '1.3.0',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Password dimenticata — recupero via email con link sicuro (scade in 1 ora)',
          'Pagina reimposta password con validazione',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Login — errore credenziali mostrato inline, senza popup',
          'Login — link "Password dimenticata?" sempre visibile sotto il form',
          'Lingua — la scelta viene memorizzata e ripristinata ad ogni apertura',
          'Email transazionale migrata su Resend per maggiore affidabilità',
        ],
      },
    ],
  },
  {
    version: '1.2.2',
    date: 'Giugno 2026',
    sections: [
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Terminologia aggiornata: "Cliente" al posto di "Sposa", "Evento" al posto di "Matrimonio"',
          'Generazione PDF aggiornata con nuova struttura dati',
          'Pagina eventi — caricamento dati corretto dopo refactor',
          'Scheda evento — visualizzazione e modifica ripristinate correttamente',
        ],
      },
      {
        tag: 'fixed',
        label: 'Risolto',
        items: [
          'Creazione evento non funzionante dopo refactor',
          'Dati non visibili nella lista eventi e nella home',
          'Contratti non filtrati correttamente nella pagina Contratti',
          'Rimosse chiamate dotenv duplicate nel backend',
          'Rimossi log di debug rimasti in produzione',
        ],
      },
    ],
  },
  {
    version: '1.2.1',
    date: '21 Aprile 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Implementato il multilingua in tutte le pagine',
        ],
      },
    ],
  },
  {
    version: '1.2.0',
    date: '1 Aprile 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Firma sposa digitale — link di condivisione e pagina firma pubblica con signature pad',
          'PDF firmato — firma sposa e owner affiancate nella sezione firme',
          'Collaborazioni tra utenti — invita colleghi con notifiche accetta/rifiuta',
          'Tab Collaboratori — team unificato con stati (assegnato/in attesa/confermato/rifiutato)',
          'Contratto bilingue IT/EN con testo libero e variabili per sezione',
          'Listino servizi nel profilo',
          'Partecipanti con ruolo e servizi richiesti',
          'Genera contratto disabilitato finché i dati obbligatori non sono completi',
          'Quantità su servizi e pacchetti con calcolo automatico subtotale',
          'Chat di supporto integrata con Crisp',
        ],
      },
      {
        tag: 'improved',
        label: 'Migliorato',
        items: [
          'Vista collaboratore — tab e sezioni sensibili nascosti, banner "organizzato da"',
          'Lista matrimoni — collaborazioni mescolate ai propri in ordine per data con badge',
          'Notifiche — fix read-all e distinzione inviti da rispondere vs già gestiti',
          'Storico contratti — badge "✓ Firmato" sulle versioni firmate',
          'Sezioni contratto tab 4 — fix caricamento lazy',
          'PDF contratto ristrutturato in moduli separati',
          'Login accetta email o username',
          'Sicurezza admin migliorata',
          'Pagina crea matrimonio — layout rinnovato con due colonne',
        ],
      },
    ],
  },
  {
    version: '1.0.0',
    date: 'Gennaio 2026',
    sections: [
      {
        tag: 'new',
        label: 'Nuovo',
        items: [
          'Prima release pubblica',
          'Gestione matrimoni e spose',
          'Generazione contratti PDF',
          'Profilo con dati studio e firma digitale',
          'Calendario matrimoni',
          'Notifiche pianificate giornaliere',
        ],
      },
    ],
  },
];

@Component({
  selector: 'app-novita',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  templateUrl: './novita.component.html',
  styleUrl: './novita.component.css',
})
export class NovitaComponent {
  currentVersion = environment.appVersion;
  changelog = CHANGELOG;
}
